/** Translations for report topic labels. */
const TOPIC_BG: Record<string, string> = {
  Technology: "Технологии",
  Finance: "Финанси",
  Banking: "Банков сектор",
  Energy: "Енергетика",
  Business: "Бизнес",
  Retail: "Търговия",
  Pharma: "Фармация",
  Workforce: "Работна сила",
  Healthcare: "Здравеопазване",
  Consumer: "Потребители",
  Crisis: "Кризи",
  Telecom: "Телекомуникации",
  "Defence & Security": "Отбрана и сигурност",
};

export function localizeTopic(topic: string | undefined, locale: string): string | undefined {
  if (!topic) return topic;
  if (locale === "bg") return TOPIC_BG[topic] ?? topic;
  return topic;
}

export function topicFallback(locale: string): string {
  return locale === "bg" ? "Доклад" : "Report";
}